var _g, _rect, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Cart"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 7087",
    filter: "url(#filter0_d_2699_112050)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 32,
    height: 32,
    rx: 4,
    fill: "#FFF9E4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shopping_cart"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2699_112050",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 4,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 8,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2699_112050)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shopping_cart_2",
    d: "M15 26C14.45 26 13.9792 25.8042 13.5875 25.4125C13.1958 25.0208 13 24.55 13 24C13 23.45 13.1958 22.9792 13.5875 22.5875C13.9792 22.1958 14.45 22 15 22C15.55 22 16.0208 22.1958 16.4125 22.5875C16.8042 22.9792 17 23.45 17 24C17 24.55 16.8042 25.0208 16.4125 25.4125C16.0208 25.8042 15.55 26 15 26ZM25 26C24.45 26 23.9792 25.8042 23.5875 25.4125C23.1958 25.0208 23 24.55 23 24C23 23.45 23.1958 22.9792 23.5875 22.5875C23.9792 22.1958 24.45 22 25 22C25.55 22 26.0208 22.1958 26.4125 22.5875C26.8042 22.9792 27 23.45 27 24C27 24.55 26.8042 25.0208 26.4125 25.4125C26.0208 25.8042 25.55 26 25 26ZM14.15 10L16.55 15H23.55L26.3 10H14.15ZM13.2 8H27.95C28.3333 8 28.625 8.17083 28.825 8.5125C29.025 8.85417 29.0333 9.2 28.85 9.55L25.3 15.95C25.1167 16.2833 24.8708 16.5417 24.5625 16.725C24.2542 16.9083 23.9167 17 23.55 17H16.1L15 19H27V21H15C14.25 21 13.6833 20.6708 13.3 20.0125C12.9167 19.3542 12.9 18.7 13.25 18.05L14.6 15.6L11 8H9V6H12.25L13.2 8Z",
    fill: "#F05802"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2699_112050",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2699_112050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2699_112050",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/Cart.19246a3f1cf2816b446d139013411cd4.svg";
export { ForwardRef as ReactComponent };